module.exports = __webpack_public_path__ + "img/thumb_01.97eb7b05.jpg";